import { render, staticRenderFns } from "./CVTemplateButton.vue?vue&type=template&id=6f57f3ad&scoped=true&"
import script from "./CVTemplateButton.vue?vue&type=script&lang=js&"
export * from "./CVTemplateButton.vue?vue&type=script&lang=js&"
import style0 from "./CVTemplateButton.vue?vue&type=style&index=0&id=6f57f3ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f57f3ad",
  null
  
)

export default component.exports